// Nav: the order button appears only after scrolling past the hero (the whole nav hides inside the order section anyway)
;(function(){
  var nav=document.getElementById('nav');
  var hero=document.querySelector('.hero');
  if(!nav) return;
  function upd(){
    nav.classList.toggle('pinned',scrollY>50);
    var limit=hero?hero.offsetTop+hero.offsetHeight-120:-1;
    nav.classList.toggle('past-hero',scrollY>limit);
  }
  addEventListener('scroll',upd,{passive:true});
  addEventListener('resize',upd);
  upd();
})();

// Nav hides while the order form is on screen
;(function(){
  var nav=document.getElementById('nav');
  var box=document.querySelector('.order-box');
  if(!nav||!box||!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(entries){
    nav.classList.toggle('nav-away',entries[0].isIntersecting);
  },{rootMargin:'-70px 0px -25% 0px',threshold:0}).observe(box);
})();

// FAQ
document.addEventListener('click', function(e){
  var btn = e.target.closest('.faq-q');
  if(!btn) return;
  var item = btn.parentElement;
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(x){ x.classList.remove('open'); });
  if(!isOpen) item.classList.add('open');
  document.querySelectorAll('.faq-q').forEach(function(q){ q.setAttribute('aria-expanded', q.parentElement.classList.contains('open') ? 'true' : 'false'); });
});

// Smooth scroll for in-page links (links to other pages work normally)
document.addEventListener('click', function(e){
  var link = e.target.closest('a[href^="#"]');
  if(!link) return;
  var id = link.getAttribute('href');
  if(id.length < 2) return;
  var t = document.querySelector(id);
  if(!t){ e.preventDefault(); window.location.href = '/' + id; return; }
  e.preventDefault();
  t.scrollIntoView({behavior:'smooth',block:'start'});
});
